import { PermissionT } from "../types";

export const enterpriseAdmin = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "enterprise_admin");
  return !!p;
};

export default enterpriseAdmin;
